
import React from "react";
import FAQItem from "./FAQItem";

const GettingStartedSection: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">Getting Started</h2>
      
      <FAQItem question="What is RemoteViz?">
        <p className="text-foreground">
          RemoteViz is a web-based platform for practicing remote viewing - the ability to perceive information about distant or unseen targets. Our system generates random targets and provides structured feedback to help you develop your remote viewing skills.
        </p>
      </FAQItem>

      <FAQItem question="How do I start a remote viewing session?">
        <p className="text-foreground">
          Simply click "Generate Location Target" or "Generate Image Target" to receive an 8-digit target code. Focus on the code, record your impressions (sketches, notes, feelings), then click "Reveal Target" to see the actual target and receive personalized feedback.
        </p>
      </FAQItem>

      <FAQItem question="Why can't I just use ChatGPT, Claude, or Gemini to give me targets?">
        <p className="text-foreground mb-6">
          Sure, you <i>can</i> ask any LLM to create a random target. But here's the catch: once you type in your impressions, those same models will almost always adjust the target to fit your feedback, even if they claim otherwise. That breaks the whole point of blind remote viewing. 
        </p>
        <p className="text-foreground mb-6">
          RemoteViz doesn't just generate targets—it locks them in securely before you ever start your session. It keeps your impressions and the original target separate, so there's no contamination. When you finally reveal the target, you know you're seeing exactly what was generated, not something re-spun to match your guesses.
        </p>
        <p className="text-foreground">
          On top of that, RemoteViz follows proven protocols developed by the CIA and SRI, so you're using a tool purpose-built for real remote viewing practice, not a general chatbot pretending to be one.
        </p>
      </FAQItem>
    </section>
  );
};

export default GettingStartedSection;
